import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaImages } from "react-icons/fa";
import CommonBanner from "../Components/Common";
import gallery_banner from "../Assests/gallery_banner.png";
import BASE_URL from "../Components/constant";
import axios from "axios";
import "./Gallery.css"; 

const Media = () => {
  const { t } = useTranslation();
  const [mediaData, setMediaData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
 
  useEffect(() => {
    const fetchMedia = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${BASE_URL}/api/v1/media`); 
        if (response.data?.success && response.data?.data) {
          setMediaData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching media:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMedia();
  }, []);
 
  const handleImageClick = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
    setShowModal(true);
  };

  // Navigation functions
  const nextImage = () => {
    if (mediaData && currentIndex < mediaData.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setSelectedImage(mediaData[currentIndex + 1]);
    }
  };

  const prevImage = () => {
    if (mediaData && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setSelectedImage(mediaData[currentIndex - 1]);
    }
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!showModal) return;
      if (e.key === "ArrowLeft") prevImage();
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "Escape") setShowModal(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showModal, currentIndex, mediaData]);

  // Skeleton loader
  const SkeletonLoader = () => (
    <div className="skeleton-wrapper">
      {[...Array(8)].map((_, idx) => (
        <div key={idx} className="skeleton-card">
          <div className="skeleton-image shimmer"></div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <CommonBanner image={gallery_banner} />
      
      <Container className="gallery-page px-3">
        <div className="gallery-header">
          <h1 className="gallery-title">Media</h1>
          <p className="gallery-subtitle">
            Capturing moments of impact and transformation
          </p>
        </div>

        {loading ? (
          <SkeletonLoader />
        ) : (
          <div className="gallery-year-section">
            <div className="year-header">
              <div className="year-badge-media">
                <FaImages className="year-icon" />
                <h2 className="year-title">All Media</h2>
              </div>
              <div className="year-divider"></div>
            </div>
            
            <Row className="gallery-grid">
              {mediaData.map((image, idx) => (
                <Col 
                  key={image.id || idx} 
                  lg={3} md={4} sm={6} xs={12} 
                  className="gallery-col"
                >
                  <div 
                    className="gallery-card"
                    onClick={() => handleImageClick(image, idx)}
                  >
                    <div className="image-wrapper">
                      <img
                        src={image.mobile_image}
                        alt={`Media ${idx + 1}`}
                        className="gallery-image"
                        loading="lazy"
                      />
                      <div className="image-overlay">
                        <div className="zoom-icon">🔍</div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        )}
        <Modal 
          show={showModal} 
          onHide={() => setShowModal(false)}
          size="lg"
          centered
          className="gallery-lightbox"
          fullscreen={true}
          scrollable={false}
        >
          <Modal.Body className="lightbox-body" style={{ padding: 0, position: 'relative' }}>
            <button 
              className="close-btn" 
              onClick={() => setShowModal(false)}
              style={{
                position: 'fixed',
                top: '20px',
                right: '20px',
                zIndex: 1060,
                background: 'rgba(0,0,0,0.7)',
                border: 'none',
                color: 'white',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px'
              }}
            >
              ✕
            </button>
            
            {selectedImage && (
              <div style={{ 
                width: '100%', 
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'black',
                position: 'relative'
              }}>
                <button 
                  onClick={prevImage}
                  style={{
                    position: 'fixed',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'rgba(0,0,0,0.5)',
                    border: 'none',
                    color: 'white',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    zIndex: 1060,
                    fontSize: '20px'
                  }}
                >
                  ◀
                </button>
                
                <img
                  src={selectedImage.desktop_image || selectedImage.mobile_image}
                  alt="Preview"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100vh',
                    objectFit: 'contain'
                  }}
                />
                
                <button 
                  onClick={nextImage}
                  style={{
                    position: 'fixed',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'rgba(0,0,0,0.5)',
                    border: 'none',
                    color: 'white',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    zIndex: 1060,
                    fontSize: '20px'
                  }}
                >
                  ▶
                </button>
                
                <div style={{
                  position: 'fixed',
                  bottom: '20px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: 'rgba(0,0,0,0.7)',
                  color: 'white',
                  padding: '5px 15px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  zIndex: 1060
                }}>
                  {currentIndex + 1} / {mediaData.length}
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default Media;